import { mountDashboardEditors, mountDashboardViews, teardownDashboardEditors } from "../dashboard_editor"
import { mountAdminSidebar } from "../admin_sidebar"
import { mountBuildingLibraryCards } from "../building_library_cards"
import { mountBuildingContacts } from "../building_contacts"
import { mountCardIndexSearch } from "../card_index_search"
import { mountContactLibrary } from "../contact_library"
import { renderPlanViewer } from "../plan_viewer"
import { mountIntegrationForms } from "../integration_form"
import { mountIntegrationGallerySearch } from "../integration_gallery_search"
import { mountMarkdownContent } from "../markdown_content"
import { mountNodeLiveViews } from "../node_live_view"
import { mountPageDrawers } from "../page_drawer"
import { mountPlanPreviewGenerator } from "../plan_preview_generator"
import { mountPlansIndexSearch } from "../plans_index_search"

const mountPlanViewer = () => {
  document.querySelectorAll("[data-plan-viewer]").forEach((element) => {
    window.Turbo?.cache?.exemptPageFromCache?.()

    if (element.dataset.viewerMounted === "true") return

    element.dataset.viewerMounted = "true"
    renderPlanViewer(element)
  })
}

const mountKnowledgeBase = () => {
  mountMarkdownContent()
}

const mountPlanPreview = () => {
  mountPlanPreviewGenerator()
}

const mountSharedPageUi = () => {
  mountAdminSidebar()
  mountBuildingContacts()
  mountBuildingLibraryCards()
  mountCardIndexSearch()
  mountContactLibrary()
  mountPageDrawers()
  mountPlansIndexSearch()
  mountIntegrationGallerySearch()
}

document.addEventListener("turbo:load", mountPlanViewer)
document.addEventListener("DOMContentLoaded", mountPlanViewer)
document.addEventListener("turbo:frame-load", mountPlanViewer)
document.addEventListener("turbo:load", mountKnowledgeBase)
document.addEventListener("DOMContentLoaded", mountKnowledgeBase)
document.addEventListener("turbo:load", mountPlanPreview)
document.addEventListener("DOMContentLoaded", mountPlanPreview)
document.addEventListener("turbo:load", mountSharedPageUi)
document.addEventListener("DOMContentLoaded", mountSharedPageUi)
document.addEventListener("turbo:load", mountNodeLiveViews)
document.addEventListener("DOMContentLoaded", mountNodeLiveViews)
document.addEventListener("turbo:load", mountIntegrationForms)
document.addEventListener("DOMContentLoaded", mountIntegrationForms)
document.addEventListener("turbo:load", mountDashboardEditors)
document.addEventListener("DOMContentLoaded", mountDashboardEditors)
document.addEventListener("turbo:load", mountDashboardViews)
document.addEventListener("DOMContentLoaded", mountDashboardViews)
document.addEventListener("turbo:frame-load", mountDashboardViews)
document.addEventListener("turbo:before-cache", teardownDashboardEditors)
